module.exports = __webpack_public_path__ + "img/numeralia_cedis_1.2ca1fda7.svg";